export default __webpack_public_path__ + "static/media/funnel-icon.44a2c994.svg";